import { z } from 'zod'

export const EmailSchema = z
  .string({ required_error: 'Email is required' })
  .email({ message: 'Email is invalid' })
  .min(3, { message: 'Email is too short' })
  .max(200, { message: 'Email is too long' })
  .transform((value) => value.toLowerCase())
